<template>
  <FlotoContentLoader :loading="loading">
    <div class="flex flex-col flex-1">
      <MTab v-if="allTabs.length > 0" v-model="currentTab" position="left">
        <MTabPane v-for="tab in allTabs" :key="tab.type" :tab="tab.title">
          <PropertyComponentListContainer
            :key="currentTab"
            :can-edit="!disabled"
            :can-create="!disabled"
            :type="tab.type"
            :fetch-fn="fetchData"
            :resource-id="resourceId"
            :resource="resource"
            :module-name="moduleName"
            as-table
            :has-actions="false"
          />
        </MTabPane>
      </MTab>
    </div>
  </FlotoContentLoader>
</template>

<script>
import CloneDeep from 'lodash/cloneDeep'
import { FormComputed } from '@state/modules/form'
import { AssetTypeComputed } from '@state/modules/asset-type'
import { CITypeComputed } from '@state/modules/ci-type'
import PropertyComponentListContainer from '../propery-component-list/propery-component-list-container'
import { searchNutanixAssetsApi } from '@modules/asset/asset-api'

export default {
  name: 'RelatedEntitiesContainer',
  components: { PropertyComponentListContainer },
  props: {
    resourceId: { type: Number, required: true },
    resource: { type: Object, required: true },
    assetConfigInfo: { type: Object, required: true },
    moduleName: { type: String, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      asset: CloneDeep(this.resource),
      loading: false,
      currentTab: 'virtual_machine',
      propertyGroupList: [
        {
          key: 'virtual_machine',
          title: `${this.$tc('virtual_machines')}`,
          type: 'virtual_machine',
          assetTypeSystemName: 'Nutanix VM',
        },
        {
          key: 'host_tab',
          title: `${this.$tc('host_tab')}`,
          type: 'host_tab',
          assetTypeSystemName: 'Nutanix Host',
        },
        {
          key: 'storage_pool',
          title: `${this.$tc('storage_pool')}`,
          type: 'storage_pool',
          assetTypeSystemName: 'Nutanix Storage Pool',
        },
        {
          key: 'storage_container',
          title: `${this.$tc('storage_container')}`,
          type: 'storage_container',
          assetTypeSystemName: 'Nutanix Storage Container',
        },
      ].map((user) => {
        return {
          ...user,
        }
      }),
    }
  },
  computed: {
    ...FormComputed,
    ...AssetTypeComputed,
    ...CITypeComputed,
    horizontalTabs() {
      return this.assetConfigInfo.listOfRelatedEntities
    },
    propertyTabs() {
      const properties = this.propertyGroupList.filter(
        (g) => this.horizontalTabs.indexOf(g.type) >= 0
      )
      return properties.map((p) => ({
        type: p.type,
        title: this.__tc(p.title),
        key: p.key,
      }))
    },
    allTabs() {
      const propertyTabs = this.propertyTabs
      return propertyTabs
    },
  },
  methods: {
    fetchData(filters, limit, offset) {
      return searchNutanixAssetsApi(
        this.moduleName,
        null,
        this.resourceId,
        limit,
        offset,
        undefined,
        { related_entities_tab: this.currentTab }
      )
    },
  },
}
</script>
